/* eslint-disable react/no-did-update-set-state, react/no-unused-state */
import cx from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import context from './context';
import getConstrainedHeight from '../../utils/getConstrainedHeight';
import inFrame from '../../utils/inFrame';
import './WidgetPage.scss';

class WidgetPage extends React.Component {
  state = {
    clientHeight: null,
    constrainHeight: false,
  }

  static childContextTypes = context;

  ref = React.createRef();

  static defaultProps = {
    children: null,
    className: undefined,
    height: undefined,
  };

  static propTypes = {
    children: PropTypes.oneOfType([
      PropTypes.element,
      PropTypes.arrayOf(
        PropTypes.element
      ),
    ]),
    className: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.arrayOf(
        PropTypes.string
      ),
    ]),
    height: PropTypes.number,
  }

  getChildContext() {
    return { page: this.state };
  }

  componentDidMount() {
    const { height } = this.props;

    if (!height) {
      return;
    }

    this.setState({
      clientHeight: this.ref?.current?.clientHeight,
    });
  }

  componentDidUpdate() {
    const clientHeight = this.ref?.current?.clientHeight;

    const { clientHeight: instanceClientHeight } = this.state;

    if (clientHeight !== instanceClientHeight) {
      this.setState({
        clientHeight,
      });
    }
  }

  shouldConstrainHeight = (height, clientHeight) => {
    if (!inFrame) {
      return false;
    }
    if (!height) {
      return false;
    }
    if (height > clientHeight) {
      return false;
    }
    return true;
  }

  render() {
    const {
      children,
      className,
      height,
      ariaLabel,
    } = this.props;

    const {
      clientHeight,
    } = this.state;

    let style = null;
    if (height && this.shouldConstrainHeight(getConstrainedHeight(height, true), clientHeight)) {
      style = {
        height: `${getConstrainedHeight(height, inFrame())}px`,
      };
    }

    return (
      <div role="dialog" {...(ariaLabel && { 'aria-label': ariaLabel })} aria-modal ref={this.ref} className={cx('WidgetPage', className)} style={style}>
        {children}
      </div>
    );
  }
}

WidgetPage.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(
      PropTypes.element
    ),
  ]),
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(
      PropTypes.string
    ),
  ]),
  height: PropTypes.number,
  ariaLabel: PropTypes.string,
};

WidgetPage.defaultProps = {
  children: null,
  className: undefined,
  height: undefined,
  ariaLabel: undefined,
};

export default WidgetPage;
